import { chakra } from '@stockx/ui';

//
// The default Chakra UI Popover component and functionality don't work
// as a static asset with our bread endpoints.
//
// These styles mirror that base level UI for the bread endpoints, but
// still allow Chakra UI to render normally within the application.

export const Container = chakra('li', {
  label: 'DropdownContainer',
});

export const staticContainerStyles = {
  '.chakra-popover__popper': {
    transform: `translate(calc(-100% + 52px), 24px)`,
  },

  '.chakra-popover__content': { display: 'none' },
  '&:hover .chakra-popover__content': { display: 'block' },
};
